export enum Role {
  Employee = 'employee',
  Admin = 'admin',
  Parent = 'parent',
  Finance = 'finance',
  Supervisor = 'supervisor',
  Teacher = 'teacher',
  Contractor = 'contractor',
}
